module.exports = __webpack_public_path__ + "img/American_Credit_Equipment_Financing_Low_Rates.7a5c0f4.png";